import styled, { css } from "styled-components";
import { Theme } from "interfaces/theme";
import { fonts } from "styles";

export const Button = styled.button.attrs({ type: "button" })`
  width: 150px;
  min-height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 23px;
  padding: 6px 6px 6px 40px;
  font-family: ${fonts.BentonSansMedium};
  font-size: 13px;
  text-transform: uppercase;
  color: #130c06;
  transition: 500ms ease;
  position: relative;

  span {
    display: block;
    width: 34px;
    height: 34px;
    background-color: #18c3de;
    border-radius: 17px;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.25);
    position: absolute;
    left: 6px;
    transition: 500ms ease;
  }
`;

interface IContainer {
  mode: Theme;
}
export const Container = styled.div<IContainer>`
  padding: 24px 48px;
  border-radius: 15px;
  backdrop-filter: blur(5px) brightness(1.15);
  position: fixed;
  z-index: 99;
  bottom: 72px;
  transition: 500ms ease;

  @media screen and (max-width: 414px) {
    bottom: 96px;
  }

  ${({ mode }) =>
    mode === "light" &&
    css`
      background-color: rgba(255, 255, 255, 0.25);
    `}
  ${({ mode }) =>
    mode === "dark" &&
    css`
      background-color: rgba(0, 0, 0, 0.25);

      ${Button} {
        background-color: #000;
        padding: 6px 40px 6px 6px;
        color: #f5eee8;
        span {
          transform: translateX(calc(150px - 45px));
          background-color: #42eea9;
        }
      }
    `}
`;
